import React from 'react';
import { Eye, Pencil, Trash2 } from 'lucide-react';

interface WorshipReport {
  id: string;
  date: string;
  messageTheme: string;
  preacher?: string;
  totalParticipants: number;
  newMembers?: number;
  notes?: string;
}

interface WorshipReportCardProps {
  report: WorshipReport;
  speakerName?: string;
  canEdit: boolean;
  canDelete: boolean;
  onPreview: (report: WorshipReport) => void;
  onEdit: (report: WorshipReport) => void;
  onDelete: () => void;
}

const MONTHS_FR = ['jan', 'fév', 'mar', 'avr', 'mai', 'juin', 'juil', 'aoét', 'sep', 'oct', 'nov', 'déc'];

export const WorshipReportCard: React.FC<WorshipReportCardProps> = ({
  report,
  speakerName,
  canEdit,
  canDelete,
  onPreview,
  onEdit,
  onDelete,
}) => {
  const d = new Date(report.date);
  const day = String(d.getDate()).padStart(2, '0');
  const month = MONTHS_FR[d.getMonth()] || '';

  return (
    <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-100">
      <div className="flex items-stretch">
        <div className="bg-vh-green text-white flex flex-col items-center justify-center px-3 min-w-[58px] py-4">
          <span className="text-2xl font-bold leading-none">{day}</span>
          <span className="text-xs uppercase opacity-75 mt-0.5">{month}</span>
        </div>
        <div className="flex-1 px-3 py-3 min-w-0">
          <p className="font-semibold text-gray-800 text-sm leading-tight line-clamp-2">
            {report.messageTheme}
          </p>
          <div className="flex items-center gap-2 mt-1.5 flex-wrap">
            <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-700">
              Présent
            </span>
            {speakerName && (
              <span className="text-xs text-gray-400 truncate">{speakerName}</span>
            )}
          </div>
        </div>
        <div className="flex flex-col items-end justify-between px-3 py-3 shrink-0">
          <div className="text-right">
            <span className="text-xl font-bold text-vh-green">{report.totalParticipants}</span>
            <p className="text-xs text-gray-400 leading-tight">présents</p>
          </div>
          <div className="flex gap-1 mt-2">
            <button onClick={() => onPreview(report)} className="p-1.5 text-gray-400 hover:text-vh-green transition-colors" title="Prévisualiser">
              <Eye size={14} />
            </button>
            {canEdit && (
              <button onClick={() => onEdit(report)} className="p-1.5 text-gray-400 hover:text-blue-600 transition-colors" title="Modifier">
                <Pencil size={14} />
              </button>
            )}
            {canDelete && (
              <button onClick={onDelete} className="p-1.5 text-gray-400 hover:text-red-500 transition-colors" title="Supprimer">
                <Trash2 size={14} />
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

